<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarCell, type RangeCalendarCellProps, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<RangeCalendarCellProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RangeCalendarCell
    :class="
      cn(
        'tw-relative tw-p-0 tw-text-center tw-text-sm focus-within:tw-relative focus-within:tw-z-20 [&:has([data-selected])]:tw-bg-neutral-100 first:[&:has([data-selected])]:tw-rounded-l-md last:[&:has([data-selected])]:tw-rounded-r-md [&:has([data-selected][data-outside-view])]:tw-bg-neutral-100/50 [&:has([data-selected][data-selection-end])]:tw-rounded-r-md [&:has([data-selected][data-selection-start])]:tw-rounded-l-md dark:[&:has([data-selected])]:tw-bg-neutral-800 dark:[&:has([data-selected][data-outside-view])]:tw-bg-neutral-800/50',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </RangeCalendarCell>
</template>
